import React from "react";
import Label from "../../../Form/Label";
import { showInfoToast } from "../../../Constant/Notification";

const ContactUs = ({ formData, setFormData, sampleGuide }) => {
  return (
    <main className="flex w-full justify-between gap-6">
      <div className="bg-white h-fit  flex flex-col gap-3 rounded-[10px] p-[30px] w-[42%]">
        <div className="text-customGreen  text-[17px] mb-4 font-semibold">
          Section Layout
        </div>
        <img
          src={sampleGuide.contactUs}
          className="w-full"
          alt="Header and Hero Preview"
        />
      </div>
      <div className="bg-white overflow-x-auto min-h-72 rounded-[10px] p-[30px] flex-1">
        <div className="flex items-center justify-between flex-1 mb-8">
          <div className="text-customGreen text-[17px] font-semibold  ">
            Contact Us Section
          </div>

          <div className="flex ">
            <label className="inline-flex mb-5 cursor-pointer">
              <input
                type="checkbox"
                checked={formData.contactUs.enable}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contactUs: {
                      ...formData.contactUs,
                      enable: e.target.checked,
                    },
                  })
                }
                className="sr-only peer"
              />
              <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
            </label>
          </div>
        </div>
        <div className="flex flex-col gap-3">
          {/* <div className="flex justify-between gap-2">
                <Label label={"Enable This Section"} />
                <div className="flex w-[75%]">
                  <label className="inline-flex mb-5 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={formData.contactUs.enable}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          contactUs: {
                            ...formData.contactUs,
                            enable: e.target.checked,
                          },
                        })
                      }
                      className="sr-only peer"
                    />
                    <div className="relative w-9 h-5 bg-red-500 rounded-full peer-checked:bg-emerald-600 after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:after:translate-x-full" />
                  </label>
                </div>
              </div> */}
          <div className="flex justify-between gap-2">
            <Label label={"Section Title"} />
            <div className="flex items-center justify-center w-[75%]">
              <input
                type="text"
                value={formData.contactUs.title}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contactUs: {
                      ...formData.contactUs,
                      title: e.target.value,
                    },
                  })
                }
                maxLength={50}
                placeholder="Enter Title"
                className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
          {/* <div className="flex justify-between gap-2">
              <Label label={"Latitude & Longitude"} />
               <div className="flex items-center justify-center gap-4 w-[75%]">

       
          <input
            type="text"
            placeholder="Enter Latitude (e.g., 12.3456)"
            value={formData.contactUs.map.coordinates.lat}
            onChange={(e) => {
              const value = e.target.value.trim();
              const cleaned = value.replace(/[^\d.\-]/g, "");
              const parsed = parseFloat(cleaned);

              if (cleaned === "" || (!isNaN(parsed) && parsed >= -90 && parsed <= 90)) {
                setFormData({
                  ...formData,
                  contactUs: {
                    ...formData.contactUs,
                    map: {
                      ...formData.contactUs.map,
                      coordinates: {
                        ...formData.contactUs.map.coordinates,
                        lat: cleaned,
                      },
                    },
                  },
                });
              } else {
                showInfoToast("Latitude must be between -90 and 90");
              }
            }}
            
            className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
          />

         
          <input
            type="text"
            placeholder="Enter Longitude (e.g., 77.1234)"
            value={formData.contactUs.map.coordinates.lng}
            onChange={(e) => {
              const value = e.target.value.trim();
              const cleaned = value.replace(/[^\d.\-]/g, "");
              const parsed = parseFloat(cleaned);

              if (cleaned === "" || (!isNaN(parsed) && parsed >= -180 && parsed <= 180)) {
                setFormData({
                  ...formData,
                  contactUs: {
                    ...formData.contactUs,
                    map: {
                      ...formData.contactUs.map,
                      coordinates: {
                        ...formData.contactUs.map.coordinates,
                        lng: cleaned,
                      },
                    },
                  },
                });
              } else {
                showInfoToast("Longitude must be between -180 and 180");
              }
            }}
            
            className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
          />
        </div>  
                  </div> */}

          <div className="flex justify-between gap-2">
            <Label label={"Latitude & Longitude"} />
            <div className="flex items-center justify-center gap-4 w-[75%]">
            <input
  type="text"
  placeholder="Enter Coordinates (e.g., 12.3456, 77.1234)"
  value={`${formData.contactUs.map.coordinates.lat}, ${formData.contactUs.map.coordinates.lng}`}
  onChange={(e) => {
    const value = e.target.value.trim();
    const parts = value.split(",").map((part) => part.trim());

    const lat = parseFloat(parts[0]);
    const lng = parseFloat(parts[1]);

    const isLatValid = !isNaN(lat) && lat >= -90 && lat <= 90;
    const isLngValid = !isNaN(lng) && lng >= -180 && lng <= 180;

    if (
      (parts.length === 2 && (isLatValid || parts[0] === "") && (isLngValid || parts[1] === "")) ||
      value === ""
    ) {
      setFormData({
        ...formData,
        contactUs: {
          ...formData.contactUs,
          map: {
            ...formData.contactUs.map,
            coordinates: {
              lat: parts[0] ?? "",
              lng: parts[1] ?? "",
            },
          },
        },
      });
    } else {
      showInfoToast("Latitude must be -90 to 90, Longitude must be -180 to 180");
    }
  }}
  className="w-full px-4 py-2 bg-slate-100 border border-slate-300 text-gray-700 rounded-md shadow-sm focus:outline-none"
/>

            </div>
          </div>

          <div className="flex justify-between gap-2">
            <Label label={"Address"} />
            <div className="flex items-center justify-center w-[75%]">
              <input
                type="text"
                value={formData.contactUs.map.address}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contactUs: {
                      ...formData.contactUs,
                      map: {
                        ...formData.contactUs.map,
                        address: e.target.value,
                      },
                    },
                  })
                }
                maxLength={120}
                placeholder="Enter Address"
                className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
          <div className="flex justify-between gap-2">
            <Label label={"Email"} />
            <div className="flex items-center justify-center w-[75%]">
              <input
                type="email"
                value={formData.contactUs.map.email}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contactUs: {
                      ...formData.contactUs,
                      map: {
                        ...formData.contactUs.map,
                        email: e.target.value,
                      },
                    },
                  })
                }
                placeholder="Enter email"
                className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
          <div className="flex justify-between gap-2">
            <Label label={"Ph number"} />
            <div className="flex items-center justify-center w-[75%]">
              <input
                type="text"
                value={formData.contactUs.map.phoneNumber}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    contactUs: {
                      ...formData.contactUs,
                      map: {
                        ...formData.contactUs.map,
                        phoneNumber: e.target.value,
                      },
                    },
                  })
                }
                maxLength={10}
                placeholder="Enter phone number"
                className="w-full px-4 py-2 bg-slate-100 border-solid border-slate-300 text-gray-700 border rounded-md shadow-sm focus:outline-none"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ContactUs;
